exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fake-fullscreen{background-color:black;position:fixed !important;left:0;right:0;top:0;bottom:0;margin:auto;z-index:2147483647}.hapyak-player-embed.fake-fullscreen{background-color:black;position:fixed !important;left:0;right:0;top:0;bottom:0;margin:auto;z-index:2147483647}\n", ""]);

